module.exports = __webpack_public_path__ + "static/media/54727287_1253962351419836_8749173416487026688_o.39488506.jpg";